import * as styles from "./ScrollAreaContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area";

import type { ScrollAreaContentProps } from "./ScrollArea.types";

export function ScrollAreaContent({
  className,
  ...props
}: ScrollAreaContentProps): JSX.Element {
  return (
    <BaseScrollArea.Content
      data-slot="scroll-area-content"
      className={clsx(styles.content, className)}
      {...props}
    />
  );
}
